export default __webpack_public_path__ + "static/media/sprite.ef3ecc6c.svg";